import React from 'react'
import styled from 'styled-components'

import { H4 } from './H4'
import { Screen } from './Screen'
import { Section } from './Section'

const Container = styled(Section.Dark) `
  padding-top: 110px;
  padding-bottom: 110px;

  @media screen and (max-width: 640px) {
    padding-top: 125px;
    padding-bottom: 90px;
  }
`

const Name = styled(H4) `
  text-align: left;
  margin-top: 0px;
  margin-bottom: 30px;
  @media screen and (max-width: 640px) {
    margin-bottom: 50px;
  }

  em {
    font-style: italic;
    font-weight: 100;
  }
`

const Text = styled.p `
  margin: 0px 0px 15px 0px;
  @media screen and (max-width: 640px) {
    margin-bottom: 25px;
  }
  color: #FFFFFF;
  font-size: 24px;
  font-weight: 300;
  letter-spacing: 2px;

  strong {
    font-weight: 600;
  }

  @media screen and (max-width: 640px) {
    font-size: 20px;
  }
`

const Closing = styled(Text) `
  margin-top: 110px;
  @media screen and (max-width: 640px) {
    margin-top: 104px;
  }
`

const Footer = () => (
  <footer>
    <Container>
      <Screen>
        <Name>Federico Zerbinati <em>Creative Consulting</em></Name>
        <Text><strong>Office</strong></Text>
        <Text>Via Antonio Canova 28, 20900 Monza (Italy)</Text>
        <Text><strong>M:</strong> +39 3477443394</Text>
        <Text><strong>E:</strong> info@federicozerbinati.com</Text>
        <Closing>2006 / P.IVA 05447710962</Closing>
      </Screen>
    </Container>
  </footer>
)

export { Footer }
